import { buildAiccMenu } from '@/next/aicc-navigation.mjs'

export const MENU_PERMISSION_MAP: Record<string, string> = {
    llm_bot: '/bots',
    tools: '/tools',
    knowledge_base: '/knowledge-base',
    channel: '/channel',
    live_chat: '/live-chat',
    chat_detail: '/chat-detail',
    voice_bot: '/dashboard',
    batch_call: '/batch-call',
    chat_bot: '/chatbot-overview',
    call_detail: '/call-detail',
    talk_detail: '/webtalk-detail',
    bill: '/bill',
    broadcast: '/broadcast',
}

const DEFAULT_HOME_PRIORITY = [
    'llm_bot',
    'tools',
    'knowledge_base',
    'channel',
    'live_chat',
    'chat_detail',
    'voice_bot',
    'batch_call',
    'broadcast',
    'chat_bot',
    'call_detail',
    'talk_detail',
    'bill',
]

export function getDefaultHomePath(menus?: string[], profile?: any): string {
    const menuSet = new Set(menus ?? [])
    for (const key of DEFAULT_HOME_PRIORITY) {
        if (menuSet.has(key)) {
            return MENU_PERMISSION_MAP[key]
        }
    }
    if (profile) {
        // AICC-only accounts (Next) land on their first AICC page instead of /bots.
        const menu = buildAiccMenu({
            menus: profile.menus,
            pdsEnabled: profile.pds_enabled,
            managementEnabled: profile.aicc_management_enabled,
            collaborationRecordsEnabled: profile.collaboration_record_read_enabled,
            operationsOverviewEnabled: profile.operations_overview_enabled,
            principalType: profile.principal_type,
            businessLines: profile.business_lines,
            capabilities: profile.capabilities,
            scopes: profile.scopes,
        })
        const keys: string[] = menu?.children.map((child: any) => child.key) ?? []
        const preferred = profile.principal_type === 'pds_agent' ? '/aicc/pds/agent'
            : profile.principal_type === 'collaboration_agent' ? '/aicc/collaboration' : undefined
        return preferred && keys.includes(preferred) ? preferred : (keys[0] ?? '/bots')
    }
    return '/bots'
}

export function getAllowedMenuKeys(menus?: string[]): Set<string> | null {
    if (!menus) return null
    return new Set(
        menus.map((m) => MENU_PERMISSION_MAP[m]).filter(Boolean)
    )
}